/**
 * Cartop schaderapport multi-step form
 */
(function () {
  var root = document.getElementById('cartop-schaderapport');
  if (!root || root.dataset.srInit) return;
  root.dataset.srInit = '1';

  var UPLOAD_ENDPOINT = '/apps/booking/upload';
  var TOKEN_ENDPOINT = '/apps/booking/upload-token';
  var MAX_BYTES = 10 * 1024 * 1024;
  var cachedToken = null;
  var cachedTokenExpires = 0;

  var photoSets = {
    Voorkant: [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Vooraanzicht', 'Maak de volledige voorkant recht van voren zichtbaar.', false],
      ['Schuin linksvoor', 'Laat de voorkant en linkerzijde samen zien.', false],
      ['Schuin rechtsvoor', 'Laat de voorkant en rechterzijde samen zien.', false],
      ['Achteraanzicht', 'Maak ook één volledig achteraanzicht ter referentie.', false],
      ['Schade van afstand', 'Laat zien waar de schade zich bevindt.', false]
    ],
    Achterkant: [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Achteraanzicht', 'Maak de volledige achterkant recht van achteren zichtbaar.', false],
      ['Schuin linksachter', 'Laat de achterkant en linkerzijde samen zien.', false],
      ['Schuin rechtsachter', 'Laat de achterkant en rechterzijde samen zien.', false],
      ['Vooraanzicht', 'Maak ook één volledig vooraanzicht ter referentie.', false],
      ['Schade van afstand', 'Laat zien waar de schade zich bevindt.', false]
    ],
    Linkerzijde: [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Volledige linkerzijde', 'Maak de volledige linkerzijde zichtbaar.', false],
      ['Schuin linksvoor', 'Laat linkerzijde en voorkant samen zien.', false],
      ['Schuin linksachter', 'Laat linkerzijde en achterkant samen zien.', false],
      ['Rechterzijde', 'Maak één foto van de tegenoverliggende zijde.', false],
      ['Schade van afstand', 'Laat zien waar de schade zit.', false]
    ],
    Rechterzijde: [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Volledige rechterzijde', 'Maak de volledige rechterzijde zichtbaar.', false],
      ['Schuin rechtsvoor', 'Laat rechterzijde en voorkant samen zien.', false],
      ['Schuin rechtsachter', 'Laat rechterzijde en achterkant samen zien.', false],
      ['Linkerzijde', 'Maak één foto van de tegenoverliggende zijde.', false],
      ['Schade van afstand', 'Laat zien waar de schade zit.', false]
    ],
    Dak: [
      ['Foto van de schade', 'Maak de schade op het dak scherp zichtbaar. Verplicht.', true],
      ['Vooraanzicht', 'Maak de volledige auto van voren zichtbaar.', false],
      ['Linkerzijde', 'Maak de volledige linkerzijde zichtbaar.', false],
      ['Rechterzijde', 'Maak de volledige rechterzijde zichtbaar.', false],
      ['Dak van afstand', 'Maak het dak zo volledig mogelijk zichtbaar.', false]
    ],
    Ruit: [
      ['Foto van de schade', 'Maak de barst of beschadiging scherp zichtbaar. Verplicht.', true],
      ['Vooraanzicht', 'Maak de volledige auto van voren zichtbaar.', false],
      ['Beschadigde ruit volledig', 'Zorg dat de hele ruit in beeld is.', false],
      ['Ruitschade van afstand', 'Laat de positie van de schade zien.', false]
    ],
    'Velg/wiel': [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Volledige zijde', 'Maak de zijde met het beschadigde wiel zichtbaar.', false],
      ['Volledig wiel', 'Fotografeer de complete velg en band.', false],
      ['Wiel schuin', 'Maak het wiel vanuit een tweede hoek zichtbaar.', false]
    ],
    Verlichting: [
      ['Foto van de schade', 'Maak de breuk of beschadiging scherp zichtbaar. Verplicht.', true],
      ['Voor- of achteraanzicht', 'Maak de zijde waarop de lamp zit volledig zichtbaar.', false],
      ['Lamp volledig', 'Maak de complete beschadigde lamp zichtbaar.', false],
      ['Lamp vanuit hoek', 'Fotografeer de lamp vanuit een tweede hoek.', false]
    ],
    Anders: [
      ['Foto van de schade', 'Maak de beschadiging scherp zichtbaar. Verplicht.', true],
      ['Vooraanzicht', 'Maak de volledige auto van voren zichtbaar.', false],
      ['Achteraanzicht', 'Maak de volledige auto van achteren zichtbaar.', false],
      ['Linkerzijde', 'Maak de volledige linkerzijde zichtbaar.', false],
      ['Rechterzijde', 'Maak de volledige rechterzijde zichtbaar.', false],
      ['Schade van afstand', 'Laat zien waar de schade zich bevindt.', false]
    ]
  };

  var carSvg =
    '<svg class="photo-icon" viewBox="0 0 220 100" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M38 66L48 43C51 35 59 30 68 30H151C160 30 168 35 172 43L184 66" stroke="#5B655F" stroke-width="5" stroke-linecap="round"/>' +
    '<path d="M29 65H190C198 65 204 71 204 79V83H15V79C15 71 21 65 29 65Z" fill="#DDE4DF" stroke="#5B655F" stroke-width="4"/>' +
    '<circle cx="48" cy="84" r="10" fill="#1B211D"/><circle cx="171" cy="84" r="10" fill="#1B211D"/>' +
    '<path d="M61 39H157" stroke="#A7B2AB" stroke-width="9" stroke-linecap="round"/></svg>';

  var form = root.querySelector('form');
  var damageAnchor = root.querySelector('#damageForm');
  var current = 0;
  var activePhotoItems = [];
  var photoUrls = [];
  var submitting = false;

  var panels = Array.prototype.slice.call(root.querySelectorAll('.panel'));
  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step-pill]'));
  var backBtn = root.querySelector('#backBtn');
  var nextBtn = root.querySelector('#nextBtn');
  var navBar = root.querySelector('#navBar');
  var grid = root.querySelector('#photoGrid');
  var plateField = root.querySelector('#plateField');
  var vinField = root.querySelector('#vinField');
  var fotoUrlsInput = root.querySelector('#sr-foto-urls');
  var bodyInput = root.querySelector('#sr-body');

  root.querySelectorAll('input[name="vehicleIdType"]').forEach(function (r) {
    r.addEventListener('change', function () {
      var useVin = root.querySelector('#idVin').checked;
      plateField.style.display = useVin ? 'none' : 'grid';
      vinField.style.display = useVin ? 'grid' : 'none';
      if (useVin) root.querySelector('#plate').value = '';
      else root.querySelector('#vin').value = '';
    });
  });

  root.querySelectorAll('input[name="location"]').forEach(function (r) {
    r.addEventListener('change', function () {
      buildPhotoGrid(r.value);
    });
  });

  function selected(name) {
    return Array.prototype.slice
      .call(root.querySelectorAll('[name="' + name + '"]:checked'))
      .map(function (x) {
        return x.value;
      });
  }

  function error(msg) {
    var box = panels[current].querySelector('.error');
    if (box) {
      box.textContent = msg;
      box.classList.add('show');
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearError() {
    var box = panels[current].querySelector('.error');
    if (box) {
      box.classList.remove('show');
      box.textContent = '';
    }
  }

  function mintUploadToken() {
    var now = Date.now();
    if (cachedToken && cachedTokenExpires - 30000 > now) {
      return Promise.resolve(cachedToken);
    }
    return fetch(TOKEN_ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || !data.success || !data.token) {
          throw new Error((data && data.error) || 'Upload token ophalen mislukt');
        }
        cachedToken = data.token;
        cachedTokenExpires = data.expiresAt
          ? Date.parse(data.expiresAt) || now + 4 * 60 * 1000
          : now + 4 * 60 * 1000;
        return cachedToken;
      });
    });
  }

  function uploadFile(file, alt) {
    return mintUploadToken().then(function (token) {
      var body = new FormData();
      body.append('file', file);
      body.append('upload_token', token);
      if (alt) body.append('alt', alt);
      return fetch(UPLOAD_ENDPOINT, {
        method: 'POST',
        body: body,
        credentials: 'same-origin'
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data || !data.success) {
            if (res.status === 401) {
              cachedToken = null;
              cachedTokenExpires = 0;
            }
            throw new Error((data && data.error) || 'Upload mislukt');
          }
          return data.url || data.file_url || data.src || '';
        });
      });
    });
  }

  function requiredPhotoCount() {
    var n = 0;
    for (var i = 0; i < activePhotoItems.length; i++) {
      if (activePhotoItems[i][2]) n++;
    }
    return n || 1;
  }

  function requiredPhotosComplete() {
    for (var i = 0; i < activePhotoItems.length; i++) {
      if (activePhotoItems[i][2] && !photoUrls[i]) return false;
    }
    return activePhotoItems.some(function (item, i) {
      return item[2] && photoUrls[i];
    });
  }

  function buildPhotoGrid(location) {
    activePhotoItems = photoSets[location] || [];
    photoUrls = activePhotoItems.map(function () {
      return '';
    });
    grid.innerHTML = '';
    root.querySelector('#photoTitle').textContent = location
      ? 'Foto’s voor: ' + location
      : 'Foto’s';
    root.querySelector('#photoIntro').textContent = location
      ? 'Alleen “Foto van de schade” is verplicht. De overige foto’s zijn optioneel, maar helpen bij een snellere beoordeling.'
      : 'De foto-opdracht wordt samengesteld zodra de schadeplek is gekozen.';
    root.querySelector('#photoTotal').textContent = String(requiredPhotoCount());

    activePhotoItems.forEach(function (item, i) {
      var id = 'sr-photo-' + i;
      var card = document.createElement('div');
      card.className = 'photo-card';
      var required = !!item[2];
      if (required) card.classList.add('photo-card--required');
      card.innerHTML =
        '<div><div class="photo-visual">' +
        carSvg +
        '<img class="preview" alt=""></div><strong>' +
        (i + 1) +
        '. ' +
        item[0] +
        (required ? ' <span class="photo-req">*</span>' : ' <span class="photo-opt">(optioneel)</span>') +
        '</strong><small>' +
        item[1] +
        '</small></div><label class="upload-btn" for="' +
        id +
        '">Foto toevoegen</label><input id="' +
        id +
        '" type="file" accept="image/*" capture="environment"><p class="photo-status" hidden></p>';
      grid.appendChild(card);

      var input = card.querySelector('input');
      var preview = card.querySelector('.preview');
      var status = card.querySelector('.photo-status');
      var btn = card.querySelector('.upload-btn');

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) {
          card.classList.remove('complete');
          btn.textContent = 'Foto toevoegen';
          preview.removeAttribute('src');
          photoUrls[i] = '';
          status.hidden = true;
          updatePhotoProgress();
          return;
        }
        if (file.size > MAX_BYTES) {
          status.hidden = false;
          status.textContent = 'Bestand is groter dan 10 MB.';
          input.value = '';
          return;
        }
        status.hidden = false;
        status.textContent = 'Uploaden…';
        btn.textContent = 'Bezig…';
        input.disabled = true;
        uploadFile(file, 'Schaderapport: ' + item[0])
          .then(function (url) {
            photoUrls[i] = url;
            card.classList.add('complete');
            btn.textContent = '✓ Foto toegevoegd';
            preview.src = URL.createObjectURL(file);
            status.hidden = true;
            updatePhotoProgress();
          })
          .catch(function (err) {
            photoUrls[i] = '';
            card.classList.remove('complete');
            btn.textContent = 'Foto toevoegen';
            preview.removeAttribute('src');
            status.hidden = false;
            status.textContent = err.message || 'Upload mislukt';
            input.value = '';
            updatePhotoProgress();
          })
          .finally(function () {
            input.disabled = false;
          });
      });
    });
    updatePhotoProgress();
  }

  function updatePhotoProgress() {
    var requiredDone = 0;
    var requiredTotal = requiredPhotoCount();
    for (var i = 0; i < activePhotoItems.length; i++) {
      if (activePhotoItems[i][2] && photoUrls[i]) requiredDone++;
    }
    root.querySelector('#photoCount').textContent = String(requiredDone);
    root.querySelector('#photoTotal').textContent = String(requiredTotal);
    root.querySelector('#photoBar').style.width = requiredTotal
      ? (requiredDone / requiredTotal) * 100 + '%'
      : '0';
  }

  function validateStep() {
    clearError();
    if (current === 0) {
      var useVin = root.querySelector('#idVin').checked;
      var vehicleId = (useVin ? root.querySelector('#vin') : root.querySelector('#plate')).value.trim();
      if (
        !vehicleId ||
        !root.querySelector('#mileage').value.trim() ||
        !root.querySelector('#make').value.trim() ||
        !root.querySelector('#model').value.trim() ||
        !root.querySelector('#driveable').value
      ) {
        error('Vul ' + (useVin ? 'het VIN-nummer' : 'het kenteken') + ' en alle verplichte voertuiggegevens in.');
        return false;
      }
    }
    if (current === 1) {
      if (!root.querySelector('[name="location"]:checked')) {
        error('Kies waar de belangrijkste schade zit.');
        return false;
      }
      if (selected('damageType').length === 0) {
        error('Kies minimaal één soort schade.');
        return false;
      }
      if (!root.querySelector('#cause').value) {
        error('Geef aan hoe de schade is ontstaan.');
        return false;
      }
      buildPhotoGrid(root.querySelector('[name="location"]:checked').value);
    }
    if (current === 2) {
      if (!requiredPhotosComplete()) {
        error('Upload minstens de verplichte foto: Foto van de schade.');
        return false;
      }
    }
    if (current === 3) {
      var ids = ['firstName', 'lastName', 'phone', 'email'];
      for (var i = 0; i < ids.length; i++) {
        if (!root.querySelector('#' + ids[i]).value.trim()) {
          error('Vul alle verplichte contactgegevens in.');
          return false;
        }
      }
      if (!root.querySelector('#email').checkValidity()) {
        error('Vul een geldig e-mailadres in.');
        return false;
      }
    }
    if (current === 4) {
      if (!root.querySelector('#agree').checked) {
        error('Bevestig eerst de toelichting over de digitale beoordeling.');
        return false;
      }
      if (!root.querySelector('#agreeTerms').checked) {
        error('Accepteer de Aanvullende Voorwaarden Schadetaxatie om verder te gaan.');
        return false;
      }
    }
    return true;
  }

  function fillReview() {
    var useVin = root.querySelector('#idVin').checked;
    var vehicleId = (useVin ? root.querySelector('#vin') : root.querySelector('#plate')).value.trim();
    root.querySelector('#reviewVehicle').textContent =
      (useVin ? 'VIN' : 'Kenteken') +
      ': ' +
      vehicleId +
      ' · ' +
      root.querySelector('#make').value +
      ' ' +
      root.querySelector('#model').value +
      ' · ' +
      root.querySelector('#mileage').value +
      ' km';
    var loc = (root.querySelector('[name="location"]:checked') || {}).value || '—';
    root.querySelector('#reviewDamage').textContent = loc + ' · ' + selected('damageType').join(', ');
    var count = root.querySelectorAll('.photo-card.complete').length;
    root.querySelector('#reviewPhotos').textContent =
      count + (count === 1 ? ' foto toegevoegd' : ' fotos toegevoegd') + ' (1 verplicht)';
    root.querySelector('#reviewContact').textContent =
      root.querySelector('#firstName').value +
      ' ' +
      root.querySelector('#lastName').value +
      ' · ' +
      root.querySelector('#email').value;
  }

  function buildBodySummary() {
    var useVin = root.querySelector('#idVin').checked;
    var vehicleId = (useVin ? root.querySelector('#vin') : root.querySelector('#plate')).value.trim();
    var loc = (root.querySelector('[name="location"]:checked') || {}).value || '';
    var lines = [
      'Schaderapport aanvraag',
      '',
      'Voertuig: ' + (useVin ? 'VIN' : 'Kenteken') + ' ' + vehicleId,
      'Kilometerstand: ' + root.querySelector('#mileage').value,
      'Merk/model: ' + root.querySelector('#make').value + ' ' + root.querySelector('#model').value,
      'Rijdbaar: ' + root.querySelector('#driveable').value,
      '',
      'Schadeplek: ' + loc,
      'Schadesoort: ' + selected('damageType').join(', '),
      'Oorzaak: ' + root.querySelector('#cause').value,
      'Toelichting: ' + (root.querySelector('#description').value || '—'),
      '',
      'Airbags: ' + root.querySelector('#safetyAirbags').value,
      'Waarschuwingslampjes: ' + root.querySelector('#safetyLights').value,
      'Vloeistoflek: ' + root.querySelector('#safetyLeak').value,
      'Anders rijgedrag: ' + root.querySelector('#safetyDrive').value,
      '',
      'Verzekering: ' + root.querySelector('#insurance').value,
      'Naam: ' + root.querySelector('#firstName').value + ' ' + root.querySelector('#lastName').value,
      'Telefoon: ' + root.querySelector('#phone').value,
      '',
      'Aanvullende voorwaarden: ' + (root.querySelector('#sr-terms-accepted') || {}).value,
      'Akkoord op: ' + (root.querySelector('#sr-terms-accepted-at') || {}).value,
      'Versie: ' + (root.querySelector('#sr-terms-version') || {}).value,
      'Document: ' + (root.querySelector('#sr-terms-document') || {}).value,
      '',
      'Foto URLs:',
      photoUrls.filter(Boolean).join('\n')
    ];
    return lines.join('\n');
  }

  function syncTermsAcceptance() {
    var accepted = root.querySelector('#agreeTerms') && root.querySelector('#agreeTerms').checked;
    var acceptedField = root.querySelector('#sr-terms-accepted');
    var atField = root.querySelector('#sr-terms-accepted-at');
    if (acceptedField) acceptedField.value = accepted ? 'Ja' : 'Nee';
    if (atField) {
      atField.value = accepted ? new Date().toISOString() : '';
    }
  }

  function syncContactFields() {
    syncTermsAcceptance();
    root.querySelector('#sr-naam').value =
      root.querySelector('#firstName').value.trim() + ' ' + root.querySelector('#lastName').value.trim();
    root.querySelector('#sr-email-sync').value = root.querySelector('#email').value.trim();
    root.querySelector('#sr-phone-sync').value = root.querySelector('#phone').value.trim();
    var loc = root.querySelector('[name="location"]:checked');
    var plek = root.querySelector('#sr-schadeplek');
    if (plek && loc) plek.value = loc.value;
    var soort = root.querySelector('#sr-schadesoort');
    if (soort) soort.value = selected('damageType').join(', ');
    if (fotoUrlsInput) fotoUrlsInput.value = photoUrls.filter(Boolean).join('\n');
    if (bodyInput) bodyInput.value = buildBodySummary();
  }

  function render() {
    panels.forEach(function (p, i) {
      p.classList.toggle('active', i === current);
    });
    steps.forEach(function (s, i) {
      s.classList.toggle('active', i === current);
      s.classList.toggle('done', i < current);
      s.querySelector('.step-num').textContent = i < current ? '✓' : String(i + 1);
    });
    backBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
    nextBtn.textContent = current === 4 ? 'Schadetaxatie aanvragen' : 'Volgende';
    navBar.style.display = current === 5 ? 'none' : 'flex';
    if (current === 4) fillReview();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function submitForm() {
    if (submitting) return;
    submitting = true;
    syncContactFields();
    nextBtn.disabled = true;
    nextBtn.textContent = 'Versturen…';
    form.submit();
  }

  backBtn.addEventListener('click', function () {
    if (current > 0) {
      current--;
      render();
    }
  });

  nextBtn.addEventListener('click', function () {
    if (!validateStep()) return;
    if (current === 4) {
      submitForm();
      return;
    }
    current++;
    render();
  });

  form.addEventListener('submit', function (e) {
    if (current !== 4 && !submitting) {
      e.preventDefault();
    }
  });

  function openTermsModal() {
    var modal = root.querySelector('#srTermsModal');
    if (!modal) return;
    var frame = root.querySelector('#srTermsFrame');
    if (frame && frame.dataset.src && (!frame.src || frame.src === 'about:blank')) {
      frame.src = frame.dataset.src;
    }
    modal.hidden = false;
    document.documentElement.classList.add('sr-terms-open');
  }

  function closeTermsModal() {
    var modal = root.querySelector('#srTermsModal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('sr-terms-open');
  }

  var openTermsBtn = root.querySelector('#srOpenTerms');
  if (openTermsBtn) {
    openTermsBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openTermsModal();
    });
  }

  root.querySelectorAll('[data-sr-close-terms]').forEach(function (el) {
    el.addEventListener('click', function () {
      closeTermsModal();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeTermsModal();
  });

  render();
})();
